import { useState } from "react";

import { Box, Button, CommonHeading, CommonPopupCrud, customUseEffect, Grid, IconButton, MuiTooltip } from "@common";
import { Card, CardContent, CardHeader, Dialog as FullScreenDialog } from "@mui/material";
import { CancelIcon, OpenWithIcon } from "@common/icons";
// ==========================================================================================================
import { Viewer, Worker } from '@react-pdf-viewer/core';

// Import styles
import '@react-pdf-viewer/core/lib/styles/index.css';
// ==========================================================================================================
const preventDefault = (e) => {
  console.log("coming here")
  e.preventDefault();
  return false;
};
// ==========================================================================================================
function ViewPdf({ fileType, fromRC360, fromProject360, showOnlyOffice, extraIds = {}, showWithLibrary, ...props }) {

  // Create plugin with custom toolbar
  const [openFullScreen, setOpenFullScreen] = useState(false);
  const [download, setDownload] = useState(false);

  const getViewUrl = () => {
    if (props?.havingViewUrl) {
      return props?.havingViewUrl;
    }

    return `${props.viewUrl}?${props.from}=${props.params?.id ? props.params?.id : props.params
      }${props?.attachmentNo ? `&stepNo=${props?.attachmentNo}` : ""}${props?.repId ? `&testReportId=${props.repId}` : ""
      }&file_name=${props.url?.fileName ? props.url?.fileName : props?.url
      }`;
  };

  const getDownloadUrl = () => {
    if (props?.variableDownload) {
      return props?.variableDownload;
    }

    return `${props.downloadUrl}?${props.from}=${props.params?.id ? props.params?.id : props.params
      }${props?.attachmentNo ? `&stepNo=${props?.attachmentNo}` : ""}${props?.repId ? `&testReportId=${props.repId}` : ""
      }&file_name=${props.url?.fileName ? props.url?.fileName : props?.url
      }`;
  };

  const variable = getViewUrl();
  const variableDownload = getDownloadUrl();
  const handleDownload = () => {
    setDownload(true);
    setTimeout(() => {
      setDownload(false);
    }, [2000]);
  };

  const openVideoTab = () => {
    const newTab = window.open();

    if (newTab) {
      newTab.document.body.innerHTML = `
    <video controls autoplay style="width:100%;height:100%">
      <source
        src="${props?.noDownload ? `${variable}#toolbar=0` : variable}"
        type="video/mp4"
      >
      Your browser does not support the video tag.
    </video>
  `;
    }
  };

  const openNewTab = () => {
    const url = props?.noDownload ? `${variable}#toolbar=0` : variable;

    if (showWithLibrary && fileType === ".pdf") {
      setOpenFullScreen(true);
      return;
    }

    if (fileType === ".mp4") {
      openVideoTab();
      return;
    }

    window.open(url);
  };

  const handleCloseFullScreen = () => {
    setOpenFullScreen(false);
  }
  const renderViewer = () => {
    if (fileType === ".mp4") {
      return (
        <video width="100%" height="100%" controls>
          <source
            src={props?.noDownload ? `${variable}#toolbar=0` : variable}
            type="video/mp4"
          />
          <track
            kind="captions"
            src={captionsUrl}
            srcLang="en"
            label="English"
            default
          />
          Your browser does not support the video tag.
        </video>
      );
    }

    if (
      showWithLibrary &&
      fileType === ".pdf" &&
      props?.noDownload
    ) {
      return <AuthenticatedPDFViewer pdfUrl={variable} />;
    }

    return (
      <iframe
        title={props.url?.fileName || "Attachment Viewer"}
        src={props?.noDownload ? `${variable}#toolbar=0` : variable}
        style={{ width: "100%", height: "500px" }}
        className="res_tcTestData"
      />
    );
  };
  return (
    <CommonPopupCrud
      heading={
        <Grid container>
          <Grid
            size={{
              md: 0.5,
              lg: 0.5,
              xl: 0.5,
              sm: 0.5,
              xs: 0.5,
            }}></Grid>
          <Grid
            size={{
              md: 9,
              lg: 9,
              xl: 9,
              sm: 9,
              xs: 9,
            }}
            style={{ display: "flex", justifyContent: "center", alignItems: "center", textAlign: "center" }}
          >
            <CommonHeading heading={props?.fileName || ""} />
          </Grid>
          <Grid
            size={{
              md: 2,
              lg: 2,
              xl: 2,
              sm: 2,
              xs: 2,
            }}
            style={{ display: "flex", justifyContent: "flex-end" }}
          >
            {props?.variableDownload && (
              <>
                <MuiTooltip title="Open with new tab">
                  <IconButton onClick={openNewTab}>
                    <OpenWithIcon />
                  </IconButton>
                </MuiTooltip>

                {!props?.noDownload && (
                  <Button onClick={handleDownload}>Download</Button>
                )}
              </>
            )}
          </Grid>
          <Grid
            size={{
              md: 0.5,
              lg: 0.5,
              xl: 0.5,
              sm: 0.5,
              xs: 0.5,
            }}></Grid>
        </Grid>
      }
      close={() => {
        props.setShowAttachment(false);
      }}
      buttonAlignRight={true}
      cancelButtonName="Close"
    >
      <Box style={{ width: "100%", height: "100%" }}>
        {renderViewer()}
        {download && (
          <iframe
            title="Download"
            src={variableDownload}
            style={{ display: "none" }}
            sandbox="allow-scripts allow-downloads"
          />
        )}

        {openFullScreen && (<FullScreenDialog
          close={handleCloseFullScreen}
          onContextMenu={preventDefault}
        >
          <Card
            className="create-pop-up"
            onContextMenu={preventDefault}
          >

            <CardHeader
              className="create-pop-up-header"
              title={<Grid container sx={{ alignItems: "center", }} className="create-pop-up-header">
                <Grid
                  size={{
                    md: 0.5,
                    lg: 0.5,
                    xl: 0.5,
                    sm: 0.5,
                    xs: 0.5,
                  }}></Grid>
                <Grid size={{
                  md: 3,
                  lg: 3,
                  xl: 3,
                  sm: 3,
                  xs: 3,
                }} style={{ display: "flex" }}>
                </Grid>
                <Grid size={{
                  md: 5,
                  lg: 5,
                  xl: 5,
                  sm: 5,
                  xs: 5,
                }}>
                  <h5
                    className="create-pop-up-header-name"
                  >
                    {props?.fileName || ''}
                  </h5>
                </Grid>
                <Grid
                  size={{
                    md: 3,
                    lg: 3,
                    xl: 3,
                    sm: 3,
                    xs: 3,
                  }}
                  sx={{ display: "flex", justifyContent: "flex-end" }}>
                </Grid>
                <Grid
                  size={{
                    md: 0.5,
                    lg: 0.5,
                    xl: 0.5,
                    sm: 0.5,
                    xs: 0.5,
                  }}
                  sx={{ display: "flex", justifyContent: "flex-end" }}>
                  <MuiTooltip title="Close">
                    <IconButton aria-label="cancel" onClick={handleCloseFullScreen}>
                      <CancelIcon color="red" />
                    </IconButton>
                  </MuiTooltip>
                </Grid>
              </Grid>}
              sx={{
                paddingBottom: "0px!important",
                "& .MuiCardHeader-action": {
                  margin: 0,
                },
              }}
            />

            <CardContent style={{ paddingBottom: 0, paddingRight: 0, paddingLeft: 0 }} onContextMenu={preventDefault}>
              <AuthenticatedPDFViewer pdfUrl={variable} />
            </CardContent>
          </Card>
        </FullScreenDialog>)}
      </Box>
    </CommonPopupCrud>
  );
}

export default ViewPdf;





const AuthenticatedPDFViewer = ({ pdfUrl, authToken }) => {
  const [pdfBlob, setPdfBlob] = useState(null);

  customUseEffect(() => {
    const fetchPDF = async () => {
      try {
        const response = await fetch(pdfUrl, {
          credentials: "include", // Send cookies with the request
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const blob = await response.blob();
        setPdfBlob(blob);
      } catch (error) {
        console.error('Error fetching PDF:', error);
      }
    };

    fetchPDF();
  }, [pdfUrl, authToken]);

  if (!pdfBlob) {
    return <div>Loading PDF...</div>;
  }

  return (
    <div aria-hidden="true" onContextMenu={preventDefault} style={{ height: '750px' }}>
      <Worker workerUrl="https://unpkg.com/pdfjs-dist@6.2.108/build/pdf.worker.min.js">
        <Viewer
          fileUrl={URL.createObjectURL(pdfBlob)}
        />
      </Worker>
    </div>
  );
};